<template>
  <page-layout
    :breadcrumbs="[
      {
        text: 'HOME',
        disabled: false,
        exact: true,
        to: '/'
      },
      {
        text: 'LIMPIEZA',
        disabled: true,
        exact: true
      }
    ]"
  >
    <v-container>
      <v-row justify="center">
        <v-col cols="auto">
          <v-autocomplete
            :items="promociones"
            label="Promoción"
            v-model="promocionSeleccionada"
            :rules="[rules.required]"
            return-object
            item-text="promotion_desc"
            item-value="promotion_code"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-tabs
        v-if="promocionSeleccionada != null && !loading"
        v-model="tab"
        background-color="transparent"
        color="basil"
        grow
      >
        <v-tab v-for="item in items" :key="item.id">
          {{ item.text }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in items" :key="item.id">
          <v-card color="basil" flat>
            <component
              :is="item.component"
              :promocionSeleccionada="promocionSeleccionada"
              :inicializado="inicializado"
              :key="item.id"
            ></component>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </page-layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import rulesMixin from '@/mixins/rules'
import LimpiezaCalendar from './LimpiezaCalendar.vue'
import LimpiezaAgenda from './LimpiezaAgenda.vue'
export default {
  name: 'GestionLimpieza',
  mixins: [rulesMixin],
  components: [LimpiezaCalendar],
  props: [],
  data() {
    return {
      loading: false,
      promocionSeleccionada: null,
      inicializado: false,
      promociones: null,
      tab: 0,
      items: [
        {
          id: 0,
          text: 'Configuración',
          component: LimpiezaCalendar
        },
        {
          id: 1,
          text: 'Agenda',
          component: LimpiezaAgenda
        }
      ]
    }
  },
  async created() {
    this.loading = true
    this.promociones = await this.loadPromotions()
    this.loading = false
    this.inicializado = true
  },
  computed: {
    ...mapGetters({
      user: 'login/user'
    })
  },
  methods: {
    ...mapActions({
      loadPromotions: 'promotions/getPromotions',
      addAlert: 'alerts/add'
    })
  },
  watch: {}
}
</script>
<style lang="sass">
.your_customized_wrapper_class
  background-color: #0aa
  color: white
.your_customized_wrapper_class.red
    background-color: red
    color: white
.your_customized_wrapper_class.blue
    background-color: #0000aa
    color: white
.your_customized_wrapper_class.your_customized_classname
    background-color: yellow
    color: black
</style>
